module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav_case"
  }, _vm._l((_vm.btnList), function(item, index) {
    return _c('li', {
      key: index,
      class: _vm.btn_index == item.path ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.onClick(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25dafb70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navTab.vue
// module id = WxdC
// module chunks = 6